<template>
    <div
        :id="id"
        :class="options?.size"
        class="tl-text-plain"
        :style="`text-align: ${options?.alignment || ''}`"
    >
        <div
            v-if="isExpandable ? !expanded : true"
            v-html="markedContent"
        />
        <div
            v-else
            v-html="markedLongContent"
        />
        <template v-if="isExpandable">
            <div style="height: 8px" />
            <div
                class="expand-icon-wrapper"
                data-testid="text-plain-expand"
                @click="expanded = !expanded"
            >
                <p>{{ !expanded ? t('expand') : t('hide') }}</p>
                <ArrowRight
                    class="expand-icon"
                    :class="{ active: expanded }"
                    size="6"
                />
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import marked from 'widget-components/utilities/marked'
import { computed, ref } from 'vue'
import { useI18n } from 'widget-components/utilities/i18n'
import ArrowRight from 'widget-components/atoms/svg/ArrowRight.vue'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    content: string
    longContent?: string
    options?: {
        size?: string
        alignment?: string
    }
}>()

const expanded = ref(false)
const isExpandable = computed(() => !!props.longContent)

const { t } = useI18n()

const markedContent = computed(() => marked(props.content))
const markedLongContent = computed(() => marked(props.longContent))
</script>

<style lang="sass" scoped>
@import "./TextPlain.sass"
</style>
